export default "__VITE_ASSET__BHIOdO7y__"